const calculate = (data, val, fd) => {
    let newData = { ...data, ...val };
    for (let [key] of Object.entries(val)) {
        switch (key) {
            case "QTcAlg": {
                const ind = data.QTcAvailableAlgs.indexOf(val.QTcAlg);
                let QTc = ind === -1 ? null : data.QTcAlgVals[ind];
                newData.QTc_ms = QTc;
                break;
            }
            case "QTmax":
            case "QTmax_ms": {
                // Расчет QTc
                // В текущем варианте QTc рассчитывает backend
                if (data.QTcAlgVals) {
                    // if ("QTc_ms" in newData) newData.QTc_ms = null;
                    break;
                }

                // Старый вариант - QTc рассчитывается локально
                const { RR_ms } = newData;
                const HR = (60 * fd) / RR_ms;
                const QT = newData[key];
                const outKey = `QTc${key.slice(5)}`;
                if ((QT || QT === 0) && (RR_ms || RR_ms === 0)) {
                    newData[outKey] = Math.floor(QT / Math.sqrt(60 / HR));
                } else newData[outKey] = null;
                break;
            }

            default:
                break;
        }
    }
    return newData;
};

export default calculate;
